// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_at-0";
export var optionCard = "_at-1";